var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiConfigService } from "./api-config.service";
import { environment } from "../../../environments/environment-wrapper";
var BrowserApiConfigService = /** @class */ (function (_super) {
    __extends(BrowserApiConfigService, _super);
    function BrowserApiConfigService(appConfig) {
        var _this = _super.call(this) || this;
        _this.appConfig = appConfig;
        _this.serverExceptions = {};
        //On browser, use cdn for all except some exceptions
        _this.serverExceptions[_this.appConfig.urls.listings.provinceCity] = true;
        _this.serverExceptions[_this.appConfig.urls.listings.gallery] = true;
        _this.serverExceptions[_this.appConfig.urls.listings.active] = true;
        _this.serverExceptions[_this.appConfig.urls.listings.offmarket] = true;
        _this.serverExceptions[_this.appConfig.urls.listings.search] = true;
        _this.serverExceptions[_this.appConfig.urls.listings.distance] = true;
        _this.serverExceptions[_this.appConfig.urls.listings.filters] = true;
        _this.serverExceptions[_this.appConfig.urls.agent.search] = true;
        _this.serverExceptions[_this.appConfig.urls.agent.filters] = true;
        _this.serverExceptions[_this.appConfig.urls.office.searchByDistance] = true;
        _this.serverExceptions[_this.appConfig.urls.office.search] = true;
        _this.serverExceptions[_this.appConfig.urls.geo.base] = true;
        _this.serverExceptions[_this.appConfig.urls.demographics.neighbourhoodPoint] = true;
        // deal with CORS issues that occurs on local host with the blog
        if (environment.isLocal)
            _this.serverExceptions[_this.appConfig.urls.blog.base] = true;
        return _this;
    }
    BrowserApiConfigService.prototype.getServerRoot = function (route) {
        return this.serverExceptions[route] ? environment.baseServerUrl : environment.cdnServerUrl;
    };
    return BrowserApiConfigService;
}(ApiConfigService));
export { BrowserApiConfigService };
